import React from 'react';
import styles from './not-moderated-cards.module.scss';
import Emoji from '@/assets/images/emoji-last-card.png';
import { Button, Typography } from '@/ui-kit';
import { routesApp } from '@/constans/routes';
import { RemoderationIcon } from '@/assets/icons';
import { Trans, useTranslation } from 'react-i18next';

interface Props {}

export const NotModeratedCards: React.FC<Props> = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <RemoderationIcon
                    className={styles.remoderationCardIcon}
                    width={56}
                    height={56} />
                <Typography
                    fontWeight="bold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    <Trans i18nKey="please_edit_your_details" />
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    {t('passing_verification_note')}
                </Typography>
                <Button
                    className={styles.button}
                    textColor="black"
                    typeColor="white"
                    isLink
                    to={routesApp.profileEdit}>
                    {t('go_to_profile')}
                </Button>
            </div>
        </div>
    );
};
